import { createActionWithSingleProps, createEntityActions } from '@aston/foundation';
import { ISubsidiaryBlockedForm, ISubsidiaryForm, ISubsidiaryFromLegalIdentifier, ISubsidiaryListItem } from 'apps/console/src/app/subsidiaries-module/models';
import { NewAccountStep } from 'apps/console/src/app/account-module/enums';
import { createAction, props } from '@ngrx/store';

const ActionPrefix = 'NewAccount';

export const SetCurrentStep = createActionWithSingleProps<NewAccountStep>(`[${ActionPrefix}] Set Current Step`);

export const SetCurrentSubsidiary = createAction(`[${ActionPrefix}] Set Current Subsidiary`, props<{ subsidiaryId: number }>());
export const SetSelectedSubsidiary = createAction(`[${ActionPrefix}] Set Selected Subsidiary`, props<{ subsidiary: ISubsidiaryListItem }>());
export const ShowSubsidiaryBlocked = createAction(`[${ActionPrefix}] Set Subsidiary Blocked`, props<{ entity: ISubsidiaryForm, blockedBy: string }>());
export const CancelCreation = createAction(`[${ActionPrefix}] Cancel Subsidiary Creation`);

export const SubsidiaryFormActions = createEntityActions<ISubsidiaryForm>(ActionPrefix, 'Subsidiary Form');
export const {
	CreateEntityRequest: SubmitSubsidiaryFormRequest,
	CreateEntitySuccess: SubmitSubsidiaryFormSuccess,
	CreateEntityFailure: SubmitSubsidiaryFormFailure
} = SubsidiaryFormActions;

export const SubsidiaryBlockedFormActions = createEntityActions<ISubsidiaryBlockedForm>(ActionPrefix, 'Subsidiary Blocked Form');
export const {
	CreateEntityRequest: SubmitSubsidiaryBlockedFormRequest,
	CreateEntitySuccess: SubmitSubsidiaryBlockedFormSuccess,
	CreateEntityFailure: SubmitSubsidiaryBlockedFormFailure
} = SubsidiaryBlockedFormActions;

export const SubsidiaryFromLegalIdentifierActions = createEntityActions<ISubsidiaryFromLegalIdentifier>(ActionPrefix, 'Subsidiary From LegalIdentifier');
export const {
	LoadEntityRequest: LoadSubsidiaryFromLegalIdentifierRequest,
	UpdateEntityRequest: UpdateSubsidiaryFromLegalIdentifierRequest,
	UpdateEntitySuccess: UpdateSubsidiaryFromLegalIdentifierSuccess,
	UpdateEntityFailure: UpdateSubsidiaryFromLegalIdentifierFailure
} = SubsidiaryFromLegalIdentifierActions;

export const SubscriptionFormActions = createEntityActions<ISubsidiaryForm>(ActionPrefix, 'Subscription Form');
export const {
	UpdateEntityRequest: SubmitSubscriptionFormRequest,
	UpdateEntitySuccess: SubmitSubscriptionFormSuccess,
	UpdateEntityFailure: SubmitSubscriptionFormFailure
} = SubscriptionFormActions;

export const SubsidiaryInitializedChanged = createAction(`[${ActionPrefix}] Subsidiary Initialized`);
export const SubsidiaryNotInitializedChanged = createAction(`[${ActionPrefix}] Subsidiary Not Initialized`);

export const RedirectToCreatedTenant = createAction(`[${ActionPrefix}] Redirect To Created Tenant`, props<{ path: string }>());
